export default __webpack_public_path__ + "static/media/code.bb04a6f7.svg";